import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRequired(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V14.4147L15.535 16.9497C15.9255 17.3403 16.5587 17.3403 16.9492 16.9497C17.3397 16.5592 17.3397 15.9261 16.9492 15.5355L14.4137 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H14.4138L16.9494 8.46447C17.3399 8.07395 17.3399 7.44078 16.9494 7.05026C16.5589 6.65973 15.9257 6.65973 15.5352 7.05026L13 9.58542V5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V9.5863L8.46394 7.05025C8.07342 6.65972 7.44025 6.65972 7.04973 7.05025C6.65921 7.44077 6.6592 8.07394 7.04973 8.46446L9.58527 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H9.58542L7.04988 15.5355C6.65936 15.9261 6.65936 16.5592 7.04988 16.9498C7.4404 17.3403 8.07357 17.3403 8.46409 16.9498L11 14.4138V19Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
